/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import logo from '../assets/images/zappy-logo.png'

const Header = () => {
  return (
    <div className='flex w-full justify-center items-center px-2 md:px-8 h-16 fixed top-0 shadow-md bg-white'>
      <div className='lg:w-10/12 xl:w-9/12 w-full'>
        <div className='w-3/6 md:w-3/6' style={{
          maxWidth: '8rem'
        }}>
          <a href={process.env.REACT_APP_WEBSITE_PATH}><img src={logo} /></a>
        </div>
      </div>
    </div>
  )
}

export default Header